// Keep the displayed price in sync with the variant submitted by the product form.
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-ddm2026-purchase]').forEach((purchase) => {
      const select = purchase.querySelector('[data-ddm2026-variants]');
      const price = purchase.querySelector('[data-ddm2026-price]');
      if (!select || !price || select.dataset.ddm2026Ready) return;
      select.dataset.ddm2026Ready = 'true';
      const updatePrice = () => {
        const option = select.selectedOptions[0];
        if (option) price.textContent = option.dataset.price;
      };
      select.addEventListener('change', updatePrice);
      updatePrice();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
